module.exports = __webpack_public_path__ + "fonts/HSESlab-Black.1fd8993.otf";